enum COOKIES_KEY {
  TOKEN = 'token',
  JWT_TOKEN = 'jwt_token',
}

export default COOKIES_KEY;
